import * as z from "zod";

export const listAeoAssistantThreads = {
  name: "listAeoAssistantThreads" as const,
  input: z.object({}),
  output: z.object({
    threads: z.array(
      z.object({
        threadId: z.string(),
        title: z.string(),
        createdAt: z.string(),
        saved: z.boolean(),
      }),
    ),
  }),
};
